module.exports = __webpack_public_path__ + "img/1098194172.66b26e4a.jpg";